import { render, staticRenderFns } from "./LoginAffiliate.vue?vue&type=template&id=bacb8ac4&scoped=true&"
import script from "./LoginAffiliate.vue?vue&type=script&lang=js&"
export * from "./LoginAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./LoginAffiliate.vue?vue&type=style&index=0&id=bacb8ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb8ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacb8ac4')) {
      api.createRecord('bacb8ac4', component.options)
    } else {
      api.reload('bacb8ac4', component.options)
    }
    module.hot.accept("./LoginAffiliate.vue?vue&type=template&id=bacb8ac4&scoped=true&", function () {
      api.rerender('bacb8ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginAffiliate.vue"
export default component.exports